import React, { useState, useEffect } from 'react';

interface MobilePlazaLayoutProps {
    leftPanel?: React.ReactNode;
    centerPanel: React.ReactNode;
    rightPanel?: React.ReactNode;
    leftSubTabs?: {
        search: React.ReactNode;
        favorites: React.ReactNode;
    };
}

type TabType = 'left' | 'center' | 'right';
type LeftSubTabType = 'search' | 'favorites';

// ひ孫１−１: 左パネル
interface LeftPanelProps {
    activeTab: TabType;
    leftPanel?: React.ReactNode;
    leftSubTabs?: {
        search: React.ReactNode;
        favorites: React.ReactNode;
    };
    activeLeftSubTab: LeftSubTabType;
    onLeftSubTabChange: (tab: LeftSubTabType) => void;
}

const LeftPanel: React.FC<LeftPanelProps> = ({
    activeTab,
    leftPanel,
    leftSubTabs,
    activeLeftSubTab,
    onLeftSubTabChange,
}) => {
    return (
        <div
            key='left-panel'
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, #f0f4ff 0%, #e8f0fe 50%, #dde9ff 100%)',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                zIndex: 100,
                opacity: activeTab === 'left' ? 1 : 0,
                pointerEvents: activeTab === 'left' ? 'auto' : 'none',
                visibility: activeTab === 'left' ? 'visible' : 'hidden',
                transition: 'opacity 0.2s ease',
            }}
        >
            {leftSubTabs ? (
                <>
                    {/* サブタブ切り替えボタン */}
                    <div
                        style={{
                            display: 'flex',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        }}
                    >
                        <button
                            type='button'
                            onClick={() => onLeftSubTabChange('search')}
                            style={{
                                flex: 1,
                                padding: '12px',
                                background:
                                    activeLeftSubTab === 'search'
                                        ? 'rgba(0, 0, 0, 0.1)'
                                        : 'transparent',
                                color: '#333',
                                border: 'none',
                                fontSize: '14px',
                                fontWeight: activeLeftSubTab === 'search' ? 'bold' : 'normal',
                                cursor: 'pointer',
                            }}
                        >
                            検索
                        </button>
                        <button
                            type='button'
                            onClick={() => onLeftSubTabChange('favorites')}
                            style={{
                                flex: 1,
                                padding: '12px',
                                background:
                                    activeLeftSubTab === 'favorites'
                                        ? 'rgba(0, 0, 0, 0.1)'
                                        : 'transparent',
                                color: '#333',
                                border: 'none',
                                fontSize: '14px',
                                fontWeight: activeLeftSubTab === 'favorites' ? 'bold' : 'normal',
                                cursor: 'pointer',
                            }}
                        >
                            お気に入り
                        </button>
                    </div>

                    {/* サブタブコンテンツ */}
                    <div style={{ flex: 1, overflow: 'hidden' }}>
                        {activeLeftSubTab === 'search' ? leftSubTabs.search : leftSubTabs.favorites}
                    </div>
                </>
            ) : (
                leftPanel || (
                    <div
                        style={{
                            textAlign: 'center',
                            color: '#333',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '20px',
                        }}
                    >
                        <div style={{ fontSize: '48px', marginBottom: '20px' }}>📋</div>
                        <div>左パネル（赤色）</div>
                        <div
                            style={{
                                fontSize: '14px',
                                fontWeight: 'normal',
                                marginTop: '10px',
                                opacity: 0.9,
                            }}
                        >
                            準備中...
                        </div>
                    </div>
                )
            )}
        </div>
    );
};

// ひ孫１−２: 中央パネル
interface CenterPanelProps {
    activeTab: TabType;
    centerPanel: React.ReactNode;
}

const CenterPanel: React.FC<CenterPanelProps> = ({ activeTab, centerPanel }) => {
    return (
        <div
            key='center-panel'
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                zIndex: 100,
                opacity: activeTab === 'center' ? 1 : 0,
                pointerEvents: activeTab === 'center' ? 'auto' : 'none',
                visibility: activeTab === 'center' ? 'visible' : 'hidden',
                transition: 'opacity 0.2s ease',
            }}
        >
            {centerPanel}
        </div>
    );
};

// ひ孫１−３: 右パネル
interface RightPanelProps {
    activeTab: TabType;
    rightPanel?: React.ReactNode;
}

const RightPanel: React.FC<RightPanelProps> = ({ activeTab, rightPanel }) => {
    return (
        <div
            key='right-panel'
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: '#ffffff',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                zIndex: 100,
                opacity: activeTab === 'right' ? 1 : 0,
                pointerEvents: activeTab === 'right' ? 'auto' : 'none',
                visibility: activeTab === 'right' ? 'visible' : 'hidden',
                transition: 'opacity 0.2s ease',
            }}
        >
            {rightPanel ? (
                <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                    {rightPanel}
                </div>
            ) : (
                <div
                    style={{
                        textAlign: 'center',
                        color: '#333333',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '20px',
                    }}
                >
                    <div style={{ fontSize: '48px', marginBottom: '20px' }}>⚙️</div>
                    <div>右パネル（白色）</div>
                    <div
                        style={{
                            fontSize: '14px',
                            fontWeight: 'normal',
                            marginTop: '10px',
                            opacity: 0.7,
                        }}
                    >
                        準備中...
                    </div>
                </div>
            )}
        </div>
    );
};

// 孫１−１: メインコンテンツ（パネルコンテナ）
interface PanelsContainerProps {
    activeTab: TabType;
    leftPanel?: React.ReactNode;
    centerPanel: React.ReactNode;
    rightPanel?: React.ReactNode;
    leftSubTabs?: {
        search: React.ReactNode;
        favorites: React.ReactNode;
    };
    activeLeftSubTab: LeftSubTabType;
    onLeftSubTabChange: (tab: LeftSubTabType) => void;
}

const PanelsContainer: React.FC<PanelsContainerProps> = ({
    activeTab,
    leftPanel,
    centerPanel,
    rightPanel,
    leftSubTabs,
    activeLeftSubTab,
    onLeftSubTabChange,
}) => {
    return (
        <div
            style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
            }}
        >
            <LeftPanel
                activeTab={activeTab}
                leftPanel={leftPanel}
                leftSubTabs={leftSubTabs}
                activeLeftSubTab={activeLeftSubTab}
                onLeftSubTabChange={onLeftSubTabChange}
            />
            <CenterPanel activeTab={activeTab} centerPanel={centerPanel} />
            <RightPanel activeTab={activeTab} rightPanel={rightPanel} />
        </div>
    );
};

// 孫２−１: タブ切り替えボタン
interface TabSwitcherProps {
    activeTab: TabType;
    onTabChange: (tab: TabType) => void;
}

const TabSwitcher: React.FC<TabSwitcherProps> = ({ activeTab, onTabChange }) => {
    return (
        <div
            style={
                {
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    padding: '8px 5px',
                    backgroundColor: '#ffffff',
                    borderTop: '2px solid #e0e0e0',
                    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)',
                    zIndex: 200,
                    position: 'fixed',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    bottom: 0,
                    borderRadius: '15px 15px 0 0',
                    maxWidth: '90%',
                    width: '90%',
                    boxSizing: 'border-box',
                    // iOS等のセーフエリア対応 + Android Chrome対応
                    paddingBottom: 'calc(8px + max(env(safe-area-inset-bottom, 0px), 0px))',
                } as React.CSSProperties
            }
        >
            <button
                type='button'
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('🔴 Left tab clicked, current activeTab:', activeTab);
                    onTabChange('left');
                    console.log('🔴 After setActiveTab, new value should be: left');
                }}
                style={{
                    flex: 1,
                    padding: '10px 5px',
                    backgroundColor: 'transparent',
                    color: activeTab === 'left' ? '#667eea' : '#999999',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '11px',
                    fontWeight: activeTab === 'left' ? 'bold' : 'normal',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '4px',
                    minWidth: 0,
                }}
            >
                <span style={{ fontSize: '20px' }}>🔍</span>
                <span>検索</span>
            </button>

            <button
                type='button'
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('🟣 Center tab clicked, current activeTab:', activeTab);
                    onTabChange('center');
                    console.log('🟣 After setActiveTab, new value should be: center');
                }}
                style={{
                    flex: 1,
                    padding: '10px 5px',
                    backgroundColor: 'transparent',
                    color: activeTab === 'center' ? '#667eea' : '#999999',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '11px',
                    fontWeight: activeTab === 'center' ? 'bold' : 'normal',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '4px',
                    minWidth: 0,
                }}
            >
                <span style={{ fontSize: '20px' }}>📞</span>
                <span>通話</span>
            </button>

            <button
                type='button'
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('⚪ Right tab clicked, current activeTab:', activeTab);
                    onTabChange('right');
                    console.log('⚪ After setActiveTab, new value should be: right');
                }}
                style={{
                    flex: 1,
                    padding: '10px 5px',
                    backgroundColor: 'transparent',
                    color: activeTab === 'right' ? '#667eea' : '#999999',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '11px',
                    fontWeight: activeTab === 'right' ? 'bold' : 'normal',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '4px',
                    minWidth: 0,
                }}
            >
                <span style={{ fontSize: '20px' }}>📋</span>
                <span>履歴</span>
            </button>
        </div>
    );
};

// 子供１: メインコンテンツエリア
interface MainContentAreaProps {
    activeTab: TabType;
    leftPanel?: React.ReactNode;
    centerPanel: React.ReactNode;
    rightPanel?: React.ReactNode;
    leftSubTabs?: {
        search: React.ReactNode;
        favorites: React.ReactNode;
    };
    activeLeftSubTab: LeftSubTabType;
    onLeftSubTabChange: (tab: LeftSubTabType) => void;
}

const MainContentArea: React.FC<MainContentAreaProps> = ({
    activeTab,
    leftPanel,
    centerPanel,
    rightPanel,
    leftSubTabs,
    activeLeftSubTab,
    onLeftSubTabChange,
}) => {
    return (
        <div
            style={{
                flex: 1,
                position: 'relative',
                overflow: 'hidden',
                minHeight: 0,
                backgroundColor:
                    activeTab === 'left'
                        ? 'rgba(255, 255, 255, 0.95)'
                        : activeTab === 'center'
                        ? 'transparent'
                        : 'rgba(255, 255, 255, 0.95)',
            }}
        >
            <PanelsContainer
                activeTab={activeTab}
                leftPanel={leftPanel}
                centerPanel={centerPanel}
                rightPanel={rightPanel}
                leftSubTabs={leftSubTabs}
                activeLeftSubTab={activeLeftSubTab}
                onLeftSubTabChange={onLeftSubTabChange}
            />
        </div>
    );
};

// 子供２: タブ切り替えエリア
interface TabSwitcherAreaProps {
    activeTab: TabType;
    onTabChange: (tab: TabType) => void;
}

const TabSwitcherArea: React.FC<TabSwitcherAreaProps> = ({ activeTab, onTabChange }) => {
    return (
        <div
            style={{
                position: 'relative',
                flexShrink: 0,
            }}
        >
            <TabSwitcher activeTab={activeTab} onTabChange={onTabChange} />
        </div>
    );
};

/**
 * スマホ用タブ切り替えレイアウトコンポーネント
 * 3つの画面を常にマウントし、タブで表示を切り替え
 */
const MobilePlazaLayout: React.FC<MobilePlazaLayoutProps> = ({
    leftPanel,
    centerPanel,
    rightPanel,
    leftSubTabs,
}) => {
    const [activeTab, setActiveTab] = useState<TabType>('center');
    const [activeLeftSubTab, setActiveLeftSubTab] = useState<LeftSubTabType>('search');

    // デバッグ用 - activeTabの変化を監視
    useEffect(() => {
        console.log('✅ activeTab changed to:', activeTab);
    }, [activeTab]);

    // デバッグ用
    console.log(
        '🔄 MobilePlazaLayout render - activeTab:',
        activeTab,
        'leftSubTabs:',
        !!leftSubTabs,
        'centerPanel:',
        !!centerPanel,
        'rightPanel:',
        !!rightPanel
    );

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100dvh',
                width: '100%',
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            <MainContentArea
                activeTab={activeTab}
                leftPanel={leftPanel}
                centerPanel={centerPanel}
                rightPanel={rightPanel}
                leftSubTabs={leftSubTabs}
                activeLeftSubTab={activeLeftSubTab}
                onLeftSubTabChange={setActiveLeftSubTab}
            />
            <TabSwitcherArea activeTab={activeTab} onTabChange={setActiveTab} />
        </div>
    );
};

export default MobilePlazaLayout;
